"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwaMiniExtensionStrings = exports.OwaMiniExtensionStringsStringModule = void 0;
/* tslint:disable */
var index_1 = require("./index");
var keys = ['appName', 'loginSuccessfulText', 'loginInProgressText', 'loginDirectionsText', 'loginCTAText', 'zeroSearchQueryTitle', 'zeroSearchQueryDescription', 'zeroSearchIllustrationAlt', 'moduleName', 'defaultTaskFolderName', 'addTaskButtonTitle', 'addTaskButtonLabel', 'markAsImportant', 'removeImportance', 'removeTask', 'markAsCompleted', 'markAsNotCompleted', 'completedSectionTitle', 'myDayTitle', 'zeroTasksLabel', 'zeroTasksIllustrationAlt', 'addFirstTaskLabel'];
exports.OwaMiniExtensionStringsStringModule = index_1.registerStringPackage('owa-mini-extension-strings', null, keys);
var exportedObject = {};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return exports.OwaMiniExtensionStringsStringModule.strings.get(key); } });
});
/**
 * Selector to return the strings collection, so it can more easily be mocked.
 */
var getOwaMiniExtensionStrings = function () { return exportedObject; };
exports.getOwaMiniExtensionStrings = getOwaMiniExtensionStrings;
exports.default = exportedObject;
